import React, { useState } from "react";
import { ICreateExpenseData, IVendor } from "../../../@types";
import { InfoCircle } from "../../../assets/icons/InfoCircle";
import { Pen } from "../../../assets/icons/PenIcon";
import { Tooltip } from "../../../assets/icons/Tooltip";
import { CreateModal } from "../../common/CreateModal";
import { MiniCard } from "../../common/TooltipCards/miniCards";
import CreateVendorModal from "../Vendor/createVendor";
import SelectVendor from "../Vendor/selectVendor";
import { useTranslation } from "react-i18next";
import TooltipDropdown from "../../common/tooltipDropdown";
import { CloseIcon } from "../../../assets/icons";

interface VendorInfoProps {
  handleSelectedVendor: (selectedVendor: IVendor | null) => void;
  formData: ICreateExpenseData;
  vendorName: IVendor | undefined;
  validationResults: ICreateExpenseData;
  setValidationResults: React.Dispatch<
    React.SetStateAction<ICreateExpenseData>
  >;
  onClearError?: () => void;
  toolTipText?: string;
}

const VendorCreateInfo: React.FC<VendorInfoProps> = ({
  handleSelectedVendor,
  formData,
  validationResults,
  setValidationResults,
  onClearError,
  vendorName,
  toolTipText,
}) => {
  const { t } = useTranslation("expenses");
  const [showSelectCustomer, setShowSelectCustomer] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const toggleBankModal = () => {
    setShowSelectCustomer(!showSelectCustomer);
  };

  const handleSetCustomerWrapper = (selectedVendor: IVendor | null) => {
    handleSelectedVendor(selectedVendor);
    if (selectedVendor) {
      setValidationResults((prevResults: any) => ({
        ...prevResults,
        vendorId: "",
      }));
    }
  };

  const handleClearVendor = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent triggering the parent's onClick
    handleSelectedVendor(null);
    if (onClearError) {
      onClearError();
    }
  };
  return (
    <div className="md:mb-[2em] ">
      <div className="flex justify-between md:mt-[1.5em] ">
        <div
          className="flex justify-start md:items-center"
          onClick={toggleBankModal}
        >
          <p
            className="xl:text-[14px]  biglg:text-[16px] md:text-[14px]  text-[14px] font-normal"
            onClick={toggleBankModal}
          >
            {t("budget.vendorName")}
          </p>

          {toolTipText && (
            <div
              className="relative lg:mt-1 pl-1 pr-12 mt-1"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <TooltipDropdown
                toolTipText={toolTipText}
                isHovered={isHovered}
              />
            </div>
          )}
        </div>
        {/* <div
       className={`p-2 cursor-pointer hidden md:flex items-end text-right py-[0.2em] rounded-md ${vendorName ? "bg-[#E0EEFE]" : ""} text-[#044E97] font-medium`}
      onClick={toggleBankModal}
    >
      {vendorName ? "Change" : ""}
    </div> */}
      </div>
      <div
        className={`lg:p-3 p-2  border border-[#A4A4A4] ${vendorName ? "bg-gray-100" : "bg-white"} cursor-pointer  md:w-[150px] w-full py-[10px] md:py-0 rounded-lg lg:w-[400px] mt-2`}
        onClick={toggleBankModal}
      >
        {vendorName ? (
          <div className="flex gap-1 items-center justify-between">
            <div>
              <p className="text-[16px]">
                <span>{vendorName.name}</span>
              </p>
              <p>
                <span>{vendorName.lastName}</span>
              </p>
            </div>

            <div onClick={handleClearVendor}>
              <CloseIcon color="red" />
            </div>
          </div>
        ) : (
          <div>
            <p className="text-center text-gray-800 text-[16px] ">Add vendor</p>
          </div>
        )}
      </div>
      {validationResults.vendorName && (
        <div className="mt-2 xl:text-[14px] lg:text-[12px] biglg:text-[12px] 2xl:text-[14px] md:text-[11px] text-[9px]">
          {validationResults.vendorName && (
            <span className="text-red-500">{validationResults.vendorName}</span>
          )}
        </div>
      )}
      {showSelectCustomer && (
        <CreateModal className="bg-white rounded-lg">
          <SelectVendor
            handleSelectedVendor={(selectedVendor) => {
              handleSetCustomerWrapper(selectedVendor);
              setShowSelectCustomer(false);
            }}
            formData={formData}
            vendor={vendorName}
            onClose={() => setShowSelectCustomer(false)}
            vendorName={vendorName}
          />
        </CreateModal>
      )}
    </div>
  );
};

export default VendorCreateInfo;